export const DATA_TEST_ID_PREFIX = 'single-select-'
export const CONTENT_TYPE = { id: 'interactivesingleselect' }
export const RADIO_BUTTON = 'radio-button-'
export const TEXT_AREA = 'textarea-'
